import React from 'react';
import EntityTable from './table/EntityTable';
import LockToggle from './LockToggle';

const _tableConfig = toggleDeviceBlocking => ({
  maxRows: 5,
  cols: [
    {
      header: 'Name',
      valueKey: 'name',
      method: name => name,
      width: '28%'
    },
    {
      header: 'Typ',
      valueKey: 'type',
      method: type => type,
      width: '28%'
    },
    {
      header: 'System',
      valueKey: 'os',
      method: os => os,
      width: '28%'
    },
    {
      header: <div style={{textAlign: 'center'}}>Gesperrt</div>,
      valueKey: '*',
      method: device => <LockToggle locked={!device.active} toggleLock={() => toggleDeviceBlocking(device)} />,
      width: '16%'
    }
  ]
});

export default ({devices, toggleDeviceBlocking}) =>
  <EntityTable tableConfig={_tableConfig(toggleDeviceBlocking)} data={devices} msg={'Noch keine Geräte eingetragen'} />;



// WEBPACK FOOTER //
// ./src/components/DeviceList.js